import { VideoMeetingGroup } from '@/types/components';
import type { VideoMeeting } from '@/types/video';

interface Params {
  meeting: VideoMeeting;
  isSummary?: boolean;
}

export const useVideoCardActions = ({ meeting, isSummary }: Params) => {
  const {
    group,
    canJoin,
    canJoinInDetails,
    canApprove,
    canDecline,
    canDeclineInDetails,
  } = meeting;

  const isJoinVisible = isSummary ? canJoinInDetails : canJoin;
  const isDeclineVisible = isSummary ? canDeclineInDetails : canDecline;
  const hasActions = isJoinVisible || canApprove || isDeclineVisible;

  return {
    isJoinVisible,
    isDeclineVisible,
    isApproveVisible: canApprove,
    hasActions,
    isJoinEnabled: group === VideoMeetingGroup.Today,
    isClickable: !isSummary,
  };
};
